module.exports = __webpack_public_path__ + "img/portaventura_rollercoaster.95c0a941.jpeg";